module.exports = __webpack_public_path__ + "static/logo_rodape-7179ee8fb3b635c5eea72dd36e4864ed.png";